export default "__VITE_ASSET__CgHyzhWw__"